import toast from 'react-hot-toast';
import create from 'zustand';

export const useDeliveryKanbanStore = create((set) => ({
  list: [],
  addCheckbox: (basketIds, status, ifood_id, with_withdrawal) =>
    set((state) => {
      const ids = Array.isArray(basketIds) ? basketIds : [basketIds];
      const ifoodIdArray = Array.isArray(ifood_id) ? ifood_id : [ifood_id];
      const withdrawalArray = Array.isArray(with_withdrawal)
        ? with_withdrawal
        : [with_withdrawal];

      const everyExists = ids.every((id) =>
        state.list.some((item) => Number(item.id) === Number(id))
      );

      const select10 = state.list.length === 10;

      if (select10 || everyExists) {
        return { list: [] };
      } else {
        const novos = ids
          .filter(
            (id) => !state.list.some((item) => Number(item.id) === Number(id))
          )
          .map((id, index) => ({
            id,
            status: status,
            ifood_id: ifoodIdArray[index] || null,
            with_withdrawal: withdrawalArray[index] || false,
          }));

        return { list: [...state.list, ...novos].slice(0, 10) };
      }
    }),

  toggleCheckbox: (basketId, status, ifood_id, with_withdrawal) =>
    set((state) => {
      const exists = state.list.some((item) => Number(item.id) === basketId);
      if (exists) {
        return {
          list: state.list.filter((item) => item.id !== basketId),
        };
      } else {
        if (state.list.length >= 10) {
          toast.error('Selecione no máximo 10 pedidos!');
          return { list: state.list };
        }
        return {
          list: [
            ...state.list,
            {
              id: basketId,
              status: status,
              ifood_id: ifood_id,
              with_withdrawal: with_withdrawal,
            },
          ],
        };
      }
    }),

  clearSelection: () => set({ list: [] }),
}));
